<template>
  <!-- <chartjs-bar-card :chartData="chartData" :chartOptions="chartOptions">
    <template slot="header">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="d-flex">
            <div class="card-title dashboard-cards-header">
              <el-select
                class="dashboardCategoryDropdown-el-select dashboardCategoryDropdown1 select-primary"
                size="small"
                placeholder="Select ROI Graph"
                @change="categoryChange"
                v-model="category.selected"
              >
                <el-option
                  v-for="option in categoryDropdown"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
            <div
              style="margin-top: auto; margin-bottom: auto"
              v-tooltip.top-end="toolTipInfo"
            >
              <img src="static/img/graphInfo.svg" class />
            </div>
          </div>
        </div>
        <div class="d-flex">
          <el-select
            class="dashboard-dropdown-el-select select-primary"
            size="small"
            placeholder="Select ROI Graph"
            v-model="subCategoryDropDownSelected.selected"
            @change="subCategoryChange"
          >
            <el-option
              v-for="option in subCategoryDropDown"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
          <div
            class="hlpicon pt-1"
            v-tooltip.top-end="toolTipInfo"
            style="display: none"
          >
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </template>
  </chartjs-bar-card> -->
  <div>
    <div class="card-header">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="d-flex">
            <div class="card-title dashboard-cards-header">
              <el-select
                class="dashboardCategoryDropdown-el-select dashboardCategoryDropdown1 select-primary"
                size="small"
                placeholder="Select ROI Graph"
                @change="categoryChange"
                v-model="category.selected"
              >
                <el-option
                  v-for="option in categoryDropdown"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
            <div
              style="margin-top: auto; margin-bottom: auto"
              v-tooltip.top-end="toolTipInfo"
            >
              <img src="static/img/graphInfo.svg" class />
            </div>
          </div>
        </div>
        <div class="d-flex">
          <el-select
            class="dashboard-dropdown-el-select select-primary"
            size="small"
            placeholder="Select ROI Graph"
            v-model="subCategoryDropDownSelected.selected"
            @change="subCategoryChange"
          >
            <el-option
              v-for="option in subCategoryDropDown"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
          <div
            class="hlpicon pt-1"
            v-tooltip.top-end="toolTipInfo"
            style="display: none"
          >
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="card-box">
        <chartjs-bar :chartData="chartData" :chartOptions="chartOptions">
        </chartjs-bar>
      </div>
    </div>
  </div>
</template>
<script>
import { vals, formatCurrency } from "../../../util";
import { Select, Option } from "element-ui";
import { ChartjsBarCard } from "src/components/index";
import { mapGetters } from "vuex";
import _ from "lodash";
import ChartjsBar from "../../Chartjs/ChartjsBar";
export default {
  name: "bar-roi-chart-card",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsBarCard,
    ChartjsBar,
  },
  computed: {
    ...mapGetters("charts", [
      "portfolioROIByProperty",
      "dashboardPortfolioROIByProperty",
    ]),
    ...mapGetters("user", ["currency"]),
    categoryOptions() {
      // get all of the non-numerical values
      let retval = [];
      retval = _.map(vals.GRAPH_OPTIONS, (v) => {
        let label = _.has(vals.HEADER_MAP, v)
          ? vals.HEADER_MAP[v]
          : _.startCase(v);
        return { label, value: v };
      });
      return _.without(retval, undefined, null);
    },
    chartData() {
      const self = this;
      //let portfolioInfo = self.portfolioROIByProperty(self.category.selected);
      let portfolioInfo = self.dashboardPortfolioROIByProperty(
        self.category.selected,
        self.subCategoryDropDownSelected.selected
      );
      self.category.title = _.has(vals.HEADER_MAP, self.category.selected)
        ? vals.HEADER_MAP[self.category.selected]
        : _.startCase(self.category.selected);
      let labels = portfolioInfo[self.subCategoryDropDownSelected.selected];
      labels = _.map(labels, (lbl) => {
        return lbl.length > 12 ? _.truncate(lbl, { length: 12 }) : lbl;
      });
      let data = {
        labels,
        datasets: [
          {
            label: "Cost",
            labels_unadultered:
              portfolioInfo[self.subCategoryDropDownSelected.selected],
            data: portfolioInfo.cost,
            backgroundColor: "#006BFD",
          },
          {
            label: "Value",
            labels_unadultered:
              portfolioInfo[self.subCategoryDropDownSelected.selected],
            data: portfolioInfo.value,
            backgroundColor: "#2EB7FF",
          },
        ],
      };
      return data;
    },
    chartOptions() {
      const self = this;
      return {
        maintainAspectRatio: this.aspectRatio,
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            title: function (toolTips, data) {
              let toolTipItem = toolTips[0];
              return data.datasets[toolTipItem.datasetIndex].labels_unadultered[
                toolTipItem.index
              ];
            },
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].label || "") +
                ": " +
                formatCurrency(
                  data.datasets[toolTipItem.datasetIndex].data[
                    toolTipItem.index
                  ] || 0,
                  self.currency.ref,
                  0,
                  true
                )
              );
            },
          },
        },
        legend: {
          position: "top",
          align: "end",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
          },
        },
        scales: {
          // xAxes: [
          //   {
          //     gridLines: {
          //       display: false
          //       //color: "black"
          //     },
          //     scaleLabel: {
          //       display: true
          //     }
          //   }
          // ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return formatCurrency(value, self.currency.ref, 0);
                },
              },
              // gridLines: {
              //   //display: false,
              //   drawBorder: true
              //   //color: "black"
              // }
              // // scaleLabel: {
              // //   display: true
              // // }
            },
          ],
        },
      };
    },
    toolTipInfo() {
      const self = this;
      // let retval = self.toolTip; // default
      // if (_.has(vals.GRAPHS.TOOLTIP_ROI_INFO, self.category.selected)) {
      //   retval = vals.GRAPHS.TOOLTIP_ROI_INFO[self.category.selected];
      // }
      // return retval;
      if (this.category.selected == "sector") {
        return "Shows the consolidated or individual Value and Cost of your portfolio companies for all sectors or the selected sector";
      }
      if (this.category.selected == "stage") {
        return "Shows the consolidated or individual Value and Cost of your portfolio companies for all stages or the selected stage";
      }
      if (this.category.selected == "geography") {
        return "Shows the consolidated or individual Value and Cost of your portfolio companies for all geographies or the selected geography";
      }
      if (this.category.selected == "status") {
        return "Shows the consolidated or individual Value and Cost of your portfolio companies for all statuses or a specific status";
      }
    },
    categoryDropdown() {
      let dropDownArray = [];
      dropDownArray[0] = { label: "ROI By Sector", value: "sector" };
      dropDownArray[1] = { label: "ROI By Stage", value: "stage" };
      dropDownArray[2] = { label: "ROI By Geography", value: "geography" };
      dropDownArray[3] = { label: "ROI By Status", value: "status" };
      return dropDownArray;
    },
    subCategoryDropDown() {
      let subCategory = this.dashboardPortfolioROIByProperty(
        this.category.selected,
        this.subCategoryDropDownSelected.selected
      )[this.category.selected];
      let retval = [];
      retval[0] = {
        label:
          this.category.selected == "sector" ||
          this.category.selected == "stage"
            ? `All ${
                this.category.selected.charAt(0).toUpperCase() +
                this.category.selected.slice(1)
              }s`
            : `All ${
                this.category.selected.charAt(0).toUpperCase() +
                this.category.selected.slice(1)
              }`,
        value: "all",
      };
      subCategory.map((item) => {
        let obj = {};
        obj.label = item;
        obj.value = item;
        retval.push(obj);
      });
      return retval;
    },
  },
  data() {
    return {
      category: {
        selected: "sector",
        title: "Sector",
      },
      categoryDropDownSelected: {
        selected: "sector",
        title: "ROI By Sector",
      },
      subCategoryDropDownSelected: {
        selected: "all",
      },
    };
  },
  props: {
    defaultSelected: {
      type: String,
      default() {
        return undefined;
      },
    },
    aspectRatio: {
      type: Boolean,
      default() {
        return false;
      },
    },
    toolTip: {
      type: String,
      default() {
        return `This chart shows a comparison of value and cost in the same category.`;
      },
    },
  },
  mounted() {
    const self = this;
    if (!_.isNil(self.defaultSelected)) {
      self.category.selected = self.defaultSelected;
      self.category.title = _.has(vals.HEADER_MAP, self.defaultSelected)
        ? vals.HEADER_MAP[self.defaultSelected]
        : _.startCase(self.defaultSelected);
      self.categoryChange();
    }
  },
  methods: {
    categoryChange() {
      this.$store.commit("charts/setCategory", this.category.selected);
      this.subCategoryDropDownSelected.selected = "all";
      this.$store.commit(
        "charts/setSubCategory",
        this.subCategoryDropDownSelected.selected
      );
    },
    subCategoryChange() {
      this.$store.commit("charts/setCategory", this.category.selected);
      this.$store.commit(
        "charts/setSubCategory",
        this.subCategoryDropDownSelected.selected
      );
    },
  },
};
</script>
<style>
.hlpicon {
  color: #b3b3b3;
  cursor: pointer;
}

.hlpicon:hover {
  color: #0097a7;
}

.dashboard-dropdown-el-select {
}
</style>